module.exports = __webpack_public_path__ + "static/media/13d.b3004cf8.png";